// Conversion factor: 1 m/s = 2.23694 mph
const MS_TO_MPH_FACTOR = 2.23694;

export const convertMsToMph = (speedInMs) => {
  if (speedInMs == null || isNaN(speedInMs)) {
    return null;
  }
  return speedInMs * MS_TO_MPH_FACTOR;
};

export const convertMphToMs = (speedInMph) => {
  if (speedInMph == null || isNaN(speedInMph)) {
    return null;
  }
  return speedInMph / MS_TO_MPH_FACTOR;
};